import { MessageCircle, Phone, ShieldOff } from 'lucide-react';
import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import { useToast } from '@/components/ui/toast-context';
import { telLink } from '@/lib/format';
import { useOpenWhatsapp } from '@/lib/queries';

/** Aviso único para los botones bloqueados por el opt-out (ficha y Mi día). */
export const OPT_OUT_NOTICE = 'El contacto pidió que no le escribamos';

/** Etiqueta «No contactar» junto al nombre cuando el contacto pidió no ser contactado. */
export function NoContactBadge() {
  return (
    <Badge tone="danger" title={OPT_OUT_NOTICE} data-testid="no-contact-badge">
      <ShieldOff className="h-3 w-3" /> No contactar
    </Badge>
  );
}

/**
 * Llamar y WhatsApp de las filas de Mi día. Respetan el «no contactar» (se deshabilitan con el
 * mismo aviso de la ficha) y WhatsApp pasa por la API para que quede registro en el lead.
 */
export function QuickContactButtons({
  leadId,
  phoneNormalized,
  contactable,
}: {
  leadId: string;
  phoneNormalized: string | null;
  contactable: boolean;
}) {
  const open = useOpenWhatsapp(leadId);
  const toast = useToast();
  const tel = telLink(phoneNormalized);
  if (!tel) return null;
  const blocked = !contactable;
  const title = blocked ? OPT_OUT_NOTICE : undefined;
  const sendWhatsapp = async () => {
    try {
      const r = await open.mutateAsync({});
      window.open(r.url, '_blank', 'noopener');
    } catch (err) {
      toast.error('No se pudo abrir WhatsApp', (err as Error).message);
    }
  };
  return (
    <>
      {blocked ? (
        <Button variant="outline" size="icon" aria-label="Llamar" title={title} disabled>
          <Phone className="h-4 w-4" />
        </Button>
      ) : (
        <Button asChild variant="outline" size="icon" aria-label="Llamar">
          <a href={tel}>
            <Phone className="h-4 w-4" />
          </a>
        </Button>
      )}
      <Button
        variant="outline"
        size="icon"
        aria-label="WhatsApp"
        title={title}
        disabled={blocked || open.isPending}
        onClick={() => void sendWhatsapp()}
      >
        <MessageCircle className="h-4 w-4" />
      </Button>
    </>
  );
}
